export default {
    confirmSaveModal: {
        title: 'Potvrdi spremanje',
        totalVolume: 'Ukupni volumen (zbroj intervala):',
        daysWithEdits: 'Dana s izmjenama od zadnjeg spremanja: {count}',
        atomicWrite: 'Ovo je atomarni upis — svih {count} vrijednosti intervala bit će spremljeno u jednoj transakciji.',
        saving: 'Spremanje...',
        confirmSave: 'Potvrdi i spremi',
        saveFailed: 'Spremanje nije uspjelo',
        notLoaded: 'Ugovor nije učitan — osvježite i pokušajte ponovno.',
        savedToast: 'Spremljeno {count} dana · {volume}',
    },
}
